module.exports = __webpack_public_path__ + "static/media/S (43).8bd8f8df.jpg";